var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommentTalkBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3035 14.3024C12.0114 16.5948 8.61733 17.09 5.83981 15.8055C5.42978 15.6404 5.09361 15.507 4.77403 15.507C3.88387 15.5123 2.77587 16.3754 2.20002 15.8002C1.62417 15.2243 2.48795 14.1155 2.48795 13.2199C2.48795 12.9003 2.35981 12.5701 2.19474 12.1593C0.909623 9.38222 1.40558 5.98702 3.69769 3.6954C6.6237 0.768324 11.3775 0.768324 14.3035 3.69465C17.2348 6.62625 17.2295 11.3761 14.3035 14.3024Z",
    stroke: "#838383",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.283 9.34635H12.2905",
    stroke: "#838383",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94221 9.34635H8.94971",
    stroke: "#838383",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60139 9.34635H5.60889",
    stroke: "#838383",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommentTalkBoard);
export default __webpack_public_path__ + "static/media/icon_comment_talk_board.a9a48e2728d0fd0a9bc778f28b207938.svg";
export { ForwardRef as ReactComponent };